import { useState, memo } from "react";
import axios from "axios";
import { HiUserAdd } from "react-icons/hi";
import { toast } from "react-hot-toast";
import { Navigate, useNavigate } from "react-router-dom";
import backarrow from "../assets/icon/arrow-right.svg";
import { motion } from "framer-motion";
import {
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
} from "react-icons/fa";

const AnimatedBackground = memo(() => {
  const icons = [
    FaBook,
    FaBookOpen,
    FaRegListAlt,
    FaDatabase,
    FaUserGraduate,
    FaChalkboardTeacher,
    FaCalculator,
    FaChartLine,
    FaCoins,
    FaPenFancy,
    FaRegFileAlt,
    FaPencilAlt,
  ];
  const rows = 5,
    cols = 11;
  const iconArray = [];

  for (let i = 0; i < rows; i++)
    for (let j = 0; j < cols; j++) {
      const Icon = icons[Math.floor(Math.random() * icons.length)];
      iconArray.push({
        Icon,
        size: 18 + Math.random() * 20,
        top: (i / rows) * 100 + Math.random() * 5,
        left: (j / cols) * 100 + Math.random() * 5,
        duration: 15 + Math.random() * 10,
        opacity: 0.15 + Math.random() * 0.25,
        xOffset: Math.random() * 10 - 5,
        yOffset: Math.random() * 10 - 5,
      });
    }

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {iconArray.map((item, i) => (
        <motion.div
          key={i}
          className="absolute text-white/50"
          style={{
            top: `${item.top}%`,
            left: `${item.left}%`,
            opacity: item.opacity,
          }}
          initial={{ scale: 0.5 }}
          animate={{
            x: [0, item.xOffset, 0],
            y: [0, item.yOffset, 0],
            scale: [0.5, 1, 0.5],
          }}
          transition={{
            duration: item.duration,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <item.Icon size={item.size} />
        </motion.div>
      ))}
    </div>
  );
});

const AddTeacher = () => {
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_URL;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [National_Code, setNational_Code] = useState("");
  const [teacherDes, setTeacherDes] = useState("");
  const [uploadimage, setUploadimage] = useState("");
  const [showuploadicon, setShowuploadicon] = useState(true);
  const [imageid, setImageid] = useState("");

  const handlechooseimage = () => document.getElementById("openimage")?.click();

  const handleuploadimage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setShowuploadicon(false);
    const formdata = new FormData();
    formdata.append("file", file);

    axios
      .post(`${API_BASE}/api/files/admin/upload-file`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        toast.success("تصویر با موفقیت آپلود شد");
        setImageid(res.data.data.fileId);
        setUploadimage(URL.createObjectURL(file));
      })
      .catch(() => {
        toast.error("خطا در آپلود");
        setShowuploadicon(true);
      });
  };

  const handleaddteacher = async () => {
    try {
      await axios.post(
        `${API_BASE}/api/teacher/Add-Teacher`,
        {
          firstName,
          lastName,
          email: email || undefined,
          mobile,
          National_Code,
          teacherDes: teacherDes || undefined,
          imageid: imageid || undefined,
        },
        { headers: { Authorization: localStorage.getItem("token") } }
      );
      toast.success("استاد با موفقیت اضافه شد");
      navigate("/Mainpage/TeachersInf");
    } catch {
      toast.error("خطا در افزودن استاد");
    }
  };

  if (!localStorage.getItem("token")) return <Navigate to="/" />;

  return (
    <div className="relative min-h-screen w-full bg-gray-800 flex items-center justify-center p-4">
      <AnimatedBackground />

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl p-6 w-full max-w-xl mx-auto border border-white/30"
      >
        {/* هدر */}
        <div className="flex items-center justify-between mb-5">
          <img
            src={backarrow}
            alt="back"
            className="w-8 h-8 cursor-pointer hover:scale-110 transition"
            onClick={() => navigate(-1)}
          />
          <h2 className="text-2xl font-bold text-gray-800">
            افزودن استاد جدید
          </h2>
          <div className="w-8" />
        </div>

        {/* آواتار */}
        <div className="flex justify-center my-5">
          <div
            onClick={handlechooseimage}
            className="relative w-24 h-24 rounded-full border-[3px] border-gray-700 overflow-hidden cursor-pointer shadow-lg hover:scale-105 transition"
          >
            <input
              type="file"
              id="openimage"
              accept="image/*"
              className="hidden"
              onChange={handleuploadimage}
            />
            {showuploadicon ? (
              <div className="w-full h-full flex items-center justify-center bg-gray-100">
                <HiUserAdd size={50} className="text-gray-600" />
              </div>
            ) : (
              <img
                src={uploadimage}
                alt="avatar"
                className="w-full h-full object-cover"
              />
            )}
          </div>
        </div>

        {/* فیلدها */}
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <Input
              value={firstName}
              setValue={setFirstName}
              placeholder="نام"
            />
            <Input
              value={lastName}
              setValue={setLastName}
              placeholder="نام خانوادگی"
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <Input value={email} setValue={setEmail} placeholder="ایمیل" />
            <Input
              value={mobile}
              setValue={setMobile}
              placeholder="موبایل"
              maxLength={11}
              onlyNumbers
            />
          </div>

          <Input
            value={National_Code}
            setValue={setNational_Code}
            placeholder="کد ملی"
            onlyNumbers
          />

          <textarea
            value={teacherDes}
            onChange={(e) => setTeacherDes(e.target.value)}
            placeholder="توضیحات (اختیاری)"
            rows={2}
            className="w-full p-3 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none resize-none text-gray-700 text-sm"
          />

          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleaddteacher}
            className="w-full py-3.5 bg-gray-800 hover:bg-gray-900 text-white font-semibold rounded-lg shadow-lg transition text-base"
          >
            افزودن استاد
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

const Input = ({ value, setValue, placeholder, maxLength, onlyNumbers }) => (
  <input
    type="text"
    value={value}
    onChange={(e) => setValue(e.target.value)}
    placeholder={placeholder}
    maxLength={maxLength}
    onKeyDown={(e) =>
      onlyNumbers &&
      !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(e.key) &&
      e.preventDefault()
    }
    className="w-full px-4 py-3 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 font-medium text-sm"
  />
);

export default AddTeacher;
